export default function PHP_file_put_contents() {
  return (
    <div>
      <h1>PHP_file_put_contents</h1>
    </div>
  );
}
